export interface GeneratedGuest {
  name: string
  initials: string
  color: string
}

export const GUEST_ANIMALS = [
  { adjective: 'Fajna', animal: 'Fretka', initial: 'F', color: '#F04248' },
  { adjective: 'Sprytny', animal: 'Szop', initial: 'S', color: '#59539F' },
  { adjective: 'Bystry', animal: 'Bóbr', initial: 'B', color: '#0078D4' },
  { adjective: 'Ciekawski', animal: 'Borsuk', initial: 'B', color: '#008272' },
  { adjective: 'Zwinny', animal: 'Zając', initial: 'Z', color: '#107C41' },
  { adjective: 'Dzielny', animal: 'Delfin', initial: 'D', color: '#2979FF' },
  { adjective: 'Wesoły', animal: 'Wilk', initial: 'W', color: '#8764B8' },
  { adjective: 'Mądry', animal: 'Mandryl', initial: 'M', color: '#D83B01' },
  { adjective: 'Śmiały', animal: 'Słoń', initial: 'S', color: '#E3008C' },
  { adjective: 'Szybki', animal: 'Sokół', initial: 'S', color: '#028090' },
  { adjective: 'Radosny', animal: 'Ryś', initial: 'R', color: '#FA7B17' },
  { adjective: 'Lojalny', animal: 'Lew', initial: 'L', color: '#FFBB00' },
  { adjective: 'Odważny', animal: 'Orzeł', initial: 'O', color: '#5331D8' },
  { adjective: 'Kolorowy', animal: 'Kameleon', initial: 'K', color: '#18A03E' },
  { adjective: 'Genialny', animal: 'Gepard', initial: 'G', color: '#EA4335' },
  { adjective: 'Troskliwy', animal: 'Tygrys', initial: 'T', color: '#D9534F' },
  { adjective: 'Ambitny', animal: 'Albatros', initial: 'A', color: '#004E8C' },
  { adjective: 'Życzliwy', animal: 'Żubr', initial: 'Ż', color: '#7A75B2' },
  { adjective: 'Pomysłowa', animal: 'Panda', initial: 'P', color: '#0D5722' },
  { adjective: 'Czuły', animal: 'Cielak', initial: 'C', color: '#F3686D' },
]

export const generateGuestUser = (): GeneratedGuest => {
  const index = Math.floor(Math.random() * GUEST_ANIMALS.length)
  const item = GUEST_ANIMALS[index]
  return {
    name: `${item.adjective} ${item.animal}`,
    initials: item.initial,
    color: item.color,
  }
}
